import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';
import { distinctUntilChanged } from 'rxjs/internal/operators/distinctUntilChanged';
import { CommonService } from 'src/app/core/_services/common/common.service';

@Component({
  selector: 'app-filter-data',
  templateUrl: './filter-data.component.html',
  styleUrls: ['./filter-data.component.scss']
})
export class FilterDataComponent implements OnInit {
  @Input() showSearch: boolean = true;
  @Input() fromSms: boolean = false;
  @Output() filterSelection = new EventEmitter<any>();
  @Input() placeholder:string;
  searchField: FormControl;
  searchText: String= '';
  isSearch = false;
  clickEventsubscription: Subscription;
  constructor(private commonService: CommonService) { 
    this.searchField = new FormControl();
    this.clickEventsubscription =    this.commonService.getClickEvent().subscribe(()=>{
      this.resetSearch();
      })
  }

  ngOnInit(): void {
    this.search()
  
  }

  search(){
    this.searchField.valueChanges.pipe(debounceTime(400), distinctUntilChanged()).subscribe(res => {
      this.searchText = res;
      this.filterSelection.emit(this.searchText);
    });
  }

   /**resetSearch */
   resetSearch() {
    this.searchField.setValue('');
  }
}
